module.exports = __webpack_public_path__ + "img/icon-burger.0763db72.svg";